import { EVENTS_SEARCH_ERROR_MESSAGES } from '../constants';
import {
  EventsSearchObject,
  ColumnType,
  EVENT_SEARCH_KEY_TYPES,
} from '../types';

// TODO: Create unit tests for the all the functions in the file

export const isFreeTextObject = (obj: EventsSearchObject): boolean => {
  return Object.keys(obj ?? {}).some(
    (k) => !EVENT_SEARCH_KEY_TYPES.includes(k as keyof EventsSearchObject),
  );
};

export const eventSearchObjectToQueryParams = (
  searchObject: EventsSearchObject,
): string => {
  let queryString = '';

  if (isFreeTextObject(searchObject)) {
    Object.values(searchObject ?? {}).forEach((v) => {
      queryString += `&freetext=${v}`;
    });
  } else {
    for (const [key, value] of Object.entries(searchObject ?? {})) {
      queryString += `&${key}=${value}`;
    }
  }

  return queryString;
};

export const parseEventsSearchInput = (input: string): EventsSearchObject => {
  const items = input.split(' ').filter(Boolean);

  if (!items.length) return null;

  const hasColumnKeys = items.some((item) => item.includes(':'));

  if (hasColumnKeys) {
    const result = {};

    for (const item of items.filter((i) => i.includes(':'))) {
      const colonIndex = item.indexOf(':');
      const key = item.slice(0, colonIndex).toLowerCase() as ColumnType;
      const value = item.slice(colonIndex + 1).trim();

      result[key] = value;
    }

    return result as EventsSearchObject;
  }

  return { 0: input.toLocaleLowerCase() };
};

export const validateEventSearchObjects = (
  prev: EventsSearchObject,
  next: EventsSearchObject,
) => {
  const prevKeys = Object.keys(prev ?? {});

  const hasEmptyRule = !next || Object.values(next ?? {}).some((v) => !v);

  if (hasEmptyRule) throw new Error(EVENTS_SEARCH_ERROR_MESSAGES.EMPTY_RULES);

  if (prevKeys.length && isFreeTextObject(prev) !== isFreeTextObject(next))
    throw new Error(EVENTS_SEARCH_ERROR_MESSAGES.KEY_AND_FREE_TEXT_SEARCH);

  return true;
};

export const mergeEventSearchObjects = (
  prev: EventsSearchObject,
  next: EventsSearchObject,
): EventsSearchObject => {
  const isFreeText = isFreeTextObject(next);

  if (isFreeText) {
    const prevValues = Object.values(prev ?? {});
    const nextValues = Object.values(next ?? {});

    return Object.fromEntries(
      [...prevValues, ...nextValues].map((v, i) => [i.toString(), v]),
    );
  }

  return { ...prev, ...next };
};
